



























































































































































































































import {
  WorkTaskStatementModel,
  AccountTypeEnum,
  TenantUserModel,
  PredicateDefinition,
  OrderByDefinition, ClosingModel, QueryOperator
} from '@/libs/Api';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import { useObjectKey } from '@/libs/common/functions/use-object-key';
import { createAggregationQueryPayload } from '@/libs/core/+state/models/aggregation-query-payload';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { workTaskStatementsStore } from '@/libs/work-task-statements/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import ClosingDialog from '../components/ClosingDialog.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudOrderBy } from '@/libs/core/+state/models/crud-order-by';
import ApiService from "@/libs/core/api-service";
import { Filters, PageFilter } from '@/filters';
import {DateRangeValue} from "@/libs/common/components/DateRangePicker.vue";

@Component({
    components: {
		ClosingDialog
    }
})
export default class Closings extends Page {

    filterStart: DateRangeValue | null = null;
    filterParty: string | null = "";
    filterState: string | null = "";
    filterUser: string | null = "";
    filterTown: string | null = "";
    filterDistrict: string | null = "";
    filterPaymentMethod: string | null = "";
    filterType: string | null = "";
    pageInitialization = true;
    mobileFiltersShow = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "workTask.time" ];
    sortDesc = [ true ];
    totalRows = 0;
    closings: ClosingModel[] = [];
    loading = false;
    making = false;
    makingClosingModel: ClosingModel | null = null;
    selected: ClosingModel[] = [];
	activeItem: ClosingModel | null = null;
	confirmSingleDialog = false;
	confirmManyDialog = false;

    get headers() {
        return [
            { text: "Období", value: "date", align: "left" },
            { text: this.$i18n.t("statements.columnClient"), value: "party.lastName", align: "left" },
            { text: this.$i18n.t("statements.columnDistrict"), value: "party.district.name", align: "left" },
            { text: this.$i18n.t("statements.columnTown"), value: "party.town.name", align: "left" },
			{ text: "Celková částka", value: "price", align: "left" },
            { text: "", value: "id", align: "left" },
        ];
    }

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Ref() exportDialog!: ExportDialog;
    @Ref() dialog!: ClosingDialog;

    @Watch("filterStart")
    @Watch("filterState")
    @Watch("filterParty")
    @Watch("filterUser")
    @Watch("filterTown")
    @Watch("filterDistrict")
    @Watch("filterPaymentMethod")
    @Watch("filterType")
    filtersChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selected = [];
        this.pageLock(this.$nextTick()).then(() => {
            this.pageIndex = 1;
            this.load();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selected = [];
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    get moneySum () {
        return workTaskStatementsStore.useGetter(CrudGetter.Sum);
    }

    get exporting(): boolean {
        return workTaskStatementsStore.useGetter(CrudGetter.Downloading);
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get isAllSelected(): boolean {
        return (this.selected.count() > 0 && this.selected.count() >= this.closings.count()) || this.selected.count() == 0;
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    created () {
        if (this.getQuery("start") != null || this.getQuery("end") != null || this.getQuery("state") != null || this.getQuery("party") != null || this.getQuery("user") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("paymentMethod") != null || this.getQuery("type") != null || this.getQueryInt("pageSize") != null) {
            if (moment(this.getQuery("start")).isValid() && moment(this.getQuery("end")).isValid() && this.getQuery("datetype") == "period") {
                this.filterStart = {
                    type: 'period',
                    fromDate: moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59")
                };
            }
            else if (moment(this.getQuery("start")).isValid() && moment(this.getQuery("end")).isValid() && this.getQuery("datetype") == "range") {
                this.filterStart = {
                    type: 'range',
                    fromDate: moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59")
                };
            }
            this.filterState = this.getQuery("state") ?? "";
            this.filterParty = this.getQuery("party") ?? "";
            this.filterUser = this.getQuery("user") ?? "";
            this.filterDistrict = this.getQuery("district") ?? "";
            this.filterTown = this.getQuery("town") ?? "";
            this.filterPaymentMethod = this.getQuery("paymentMethod") ?? "";
            this.filterType = this.getQuery("type") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            // this.filterStart = moment(Filters.loadFilter('Global', 'start')).isValid() ? moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00") : moment().add(-1, "month").startOf("month").format("YYYY-MM-DDT00:00:00");
            if (moment(Filters.loadFilter('Global', 'start')).isValid() && moment(Filters.loadFilter('Global', 'end')).isValid() && Filters.loadFilter('Global', 'datetype') == "period") {
                this.filterStart = {
                    type: 'period',
                    fromDate: moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(Filters.loadFilter('Global', 'end')).format("YYYY-MM-DDT23:59:59")
                };
            }
            else if (moment(Filters.loadFilter('Global', 'start')).isValid() && moment(Filters.loadFilter('Global', 'end')).isValid() && Filters.loadFilter('Global', 'datetype') == "range") {
                this.filterStart = {
                    type: 'range',
                    fromDate: moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(Filters.loadFilter('Global', 'end')).format("YYYY-MM-DDT23:59:59")
                };
            }
            this.filterParty = Filters.loadFilter('Billings', 'party') ?? null;
            this.filterDistrict = Filters.loadFilter('Billings', 'district') ?? null;
            this.filterTown = Filters.loadFilter('Billings', 'town') ?? null;
            this.filterUser = Filters.loadFilter('Billings', 'user') ?? null;
            this.filterPaymentMethod = Filters.loadFilter('Billings', 'paymentMethod') ?? null;
            this.pageSize = Number(Filters.loadFilter('Billings', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
    }

    mounted () {
        this.load();
    }

    saveQuery () {
        this.setQuery("datetype", this.filterStart?.type ?? null);
        this.setQuery("start", moment(this.filterStart?.fromDate).format("YYYY-MM-DD"));
        this.setQuery("end", moment(this.filterStart?.toDate).format("YYYY-MM-DD"));
        this.setQuery("state", this.filterState);
        this.setQuery("party", this.filterParty);
        this.setQuery("user", this.filterUser);
        this.setQuery("district", this.filterDistrict);
        this.setQuery("town", this.filterTown);
        this.setQuery("paymentMethod", this.filterPaymentMethod);
        this.setQuery("type", this.filterType);
        this.setQuery("pageSize", this.pageSize?.toString());
        const filters: PageFilter = {
            pageName: 'Billings',
            filters: [
                { name: 'party', value: this.filterParty },
                { name: 'district', value: this.filterDistrict },
                { name: 'town', value: this.filterTown },
                { name: 'user', value: this.filterUser },
                { name: 'paymentMethod', value: this.filterPaymentMethod },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
        const globalFilters: PageFilter = {
            pageName: 'Global',
            filters: [
                { name: 'datetype', value: this.filterStart?.type ?? null },
                { name: 'start', value: moment(this.filterStart?.fromDate).format("YYYY-MM-DD") },
                { name: 'end', value: moment(this.filterStart?.toDate).format("YYYY-MM-DD") },
            ]
        };
        Filters.saveFilters(globalFilters);
    }

    clearFilters () {
        this.filterStart = {
            type: "period",
            fromDate: moment().add(-1, "month").startOf("month").format("YYYY-MM-DDT00:00:00"),
            toDate: moment().add(-1, "month").endOf("month").format("YYYY-MM-DDT23:59:59")
        };
        this.filterState = null;
        this.filterParty = null;
        this.filterUser = null;
        if (this.isAdmin) {
            this.filterDistrict = null;
        }
        this.filterTown = null;
        this.filterPaymentMethod = null;
        this.filterType = null;
    }

    load () {
        const orderBy: CrudOrderBy<WorkTaskStatementModel>[] = [];
        if (this.sortBy.length == 0) {
            orderBy.push({
                field: "workTask.time",
                index: 1,
                order: "desc"
            });
        }
        else {
            orderBy.push({
                field: this.sortBy.first(),
                index: 1,
                order: this.sortDesc.first() ? "desc" : "asc"
            });
        }
        this.loading = true;
        ApiService.api.getClosingBatch(this.pageIndex, this.pageSize, {
          predicates: this.getFilters() as PredicateDefinition[],
          orderby: orderBy as OrderByDefinition[]
        }).then((x: any) => {
            this.closings = x.data.returnValue.items;
            this.totalRows = x.data.returnValue.rowCount;
            this.loading = false;
            this.pageInitialization = false;
        });
        this.loadSum();
    }

	makeClosingClick() {
		this.confirmManyDialog = true;
	}

    makeClosing() {
		this.making = true;
		const filters = this.getFilters() as PredicateDefinition[];
		if (this.selected.count() > 0 && this.selected.count() < this.closings.count()) {
			filters.push({ field: "workTask.partyWorkDay.partyId", op: QueryOperator.In, comparand: this.selected.select(x => x.partyId).toArray() })
		}
		ApiService.api.makeClosingBatch({
			predicates: filters,
			orderby: []
		}).then(() => {
			this.confirmManyDialog = false;
			this.making = false;
			this.load();
		}).catch(() => {
			this.making = false;
		});
    }

	makeClosingOfClientClick(item: ClosingModel) {
		this.confirmSingleDialog = true;
		this.activeItem = item;
	}

    makeClosingOfClient(item: ClosingModel) {
        this.makingClosingModel = item;
        const filters = this.getFilters() as PredicateDefinition[];
        filters.push({ field: "workTask.partyWorkDay.partyId", op: QueryOperator.Eq, comparand: item.partyId })
        filters.push({ field: "workTask.time", op: QueryOperator.Gte, comparand: moment(item.date).startOf("month") })
        filters.push({ field: "workTask.time", op: QueryOperator.Lte, comparand: moment(item.date).endOf("month") })
        ApiService.api.makeClosingBatch({
            predicates: filters,
            orderby: []
        }).then(() => {
			this.confirmSingleDialog = false;
            this.makingClosingModel = null;
            this.load();
        }).catch(() => {
            this.makingClosingModel = null;
        });
    }

    loadSum () {
        workTaskStatementsStore.dispatch(CrudAction.GetSum, createAggregationQueryPayload(this.getFilters() as any, useObjectKey<WorkTaskStatementModel>("price")))
    }

    getFilters(): PredicateDefinition[] {

        let filters: PredicateDefinition[] = [
          { field: "billingId", op: QueryOperator.Eq, comparand: null }
        ];
        
        if (this.filterStart?.fromDate) {
            filters.push({
                field: "workTask.time",
                op: QueryOperator.Gte,
                comparand: moment(this.filterStart.fromDate).format("YYYY-MM-DDT00:00:00")
            });
        }
        
        if (this.filterStart?.toDate) {
            filters.push({
                field: "workTask.time",
                op: QueryOperator.Lte,
                comparand: moment(this.filterStart.toDate).format("YYYY-MM-DDT23:59:59")
            });
        }
        
        if (this.filterParty) 
            filters.push({ field: "workTask.partyWorkDay.partyId", op: QueryOperator.Eq, comparand: this.filterParty });
        
        if (this.filterState) 
            filters.push({ field: "workTask.partyWorkDay.party.clientStateId", op: QueryOperator.Eq, comparand: this.filterState });
        
        if (this.filterUser) 
            filters.push({ field: "userId", op: QueryOperator.Eq, comparand: this.filterUser });
        
        if (this.filterDistrict) 
            filters.push({ field: "workTask.partyWorkDay.party.districtId", op: QueryOperator.Eq, comparand: this.filterDistrict });

        if (this.filterTown) 
            filters.push({ field: "workTask.partyWorkDay.party.townId", op: QueryOperator.Eq, comparand: this.filterTown });

        if (this.filterPaymentMethod) 
            filters.push({ field: "workTask.partyWorkDay.party.paymentMethodId", op: QueryOperator.Eq, comparand: this.filterPaymentMethod });
        
        if (this.filterType) 
            filters.push({ field: "workTask.catalogueItem.billingType", op: QueryOperator.Eq, comparand: this.filterType });
        
        return filters;

    }

    exportClick () {
        this.exportDialog.open();
    }

    openStatement (item: any) {
        this.dialog.open(item.partyId, this.getFilters());
    }

}
